var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1c437251289d7a2286d3c3c31985b9d017059082"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["maxima-go@maxima-go"]={id:"1c437251289d7a2286d3c3c31985b9d017059082"};
      